module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VideoChallenge'), _vm._v(" "), _c('charts'), _vm._v(" "), _c('category')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408f5cc1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 306
// module chunks = 1